module.exports = __webpack_public_path__ + "img/kaoqinguanli.f4f02ac4.png";